"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var isNil = function isNil(value) {
  return value === null || value === undefined;
};

var _default = isNil;
exports["default"] = _default;